var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"comfirmContent"},[_c('div',{staticClass:"amap-wrapper amap-page-container"},[_c('el-amap',{staticClass:"amap-box",attrs:{"vid":"amapDemo","plugin":_vm.plugin,"center":_vm.center,"zoom":_vm.zoom,"events":_vm.events}},[_c('el-amap-marker',{attrs:{"position":_vm.position}})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }